import AssetsBaseSource from './AssetsBaseSource';

export default class SelectedAssetSource extends AssetsBaseSource {
  /** @var {String} id */
  static id = 'selected-asset';
}
